var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.317 1.067a.625.625 0 1 0-.884-.884zM5.125 9.375l-.442.442c.244.244.64.244.884 0zM1.192 4.558a.625.625 0 1 0-.884.884zM13.433.183l-8.75 8.75.884.884 8.75-8.75zm-7.866 8.75L1.192 4.558l-.884.884 4.375 4.375z"
  })));
};
export default SvgChecked;